import React, { useState } from 'react';
import update from 'react-addons-update';

import Modal from '../../../common/components/Modal';

const EncoderCreate = props => {
    const [newEncoder, setNewEncoder] = useState({
        simpleName: '',
        description: '',
        streamName: ''
    })

    const handleChange = (event) => {
        var updates = {};
        var valid = true;
        if (event.target.name == 'streamName' && event.target.value.contains(' ')) valid = false;
        if (valid) {
            updates[event.target.name] = {$set: event.target.value};
            setNewEncoder(update(newEncoder, updates))
        }
    }

    return (<Modal
        saveAction={<button className="btn btn-primary" onClick={props.save.bind(null, newEncoder)}>
            <i className="fa fa-save"/> Save
        </button>}
        cancelModal={props.toggleCreateModal}>
        <Modal.Header>Create New Encoder</Modal.Header>
        <Modal.Body>
            <label>Encoder Name</label>
            <input className="form-control" name="simpleName" value={newEncoder.simpleName} onChange={handleChange} placeholder="Required"/>

            <div style={{margin: '2rem 0'}}/>

            <label>Stream Name <small>No Spaces Allowed</small></label>
            <input className="form-control" name="streamName" value={newEncoder.streamName} onChange={handleChange} placeholder="Required"/>

            <div style={{margin: '2rem 0'}}/>

            <label>Encoder Description</label>
            <textarea className="form-control" name="description" value={newEncoder.description} onChange={handleChange}></textarea>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
    </Modal>);
}

export default EncoderCreate;
